<template>
  <div class="container-fluid" :class="isMobile && 'position-relative'">
    <navigation ref="nav" :user-info="this.user.profile" />
    <window-resize />
    <transition name="slide">
      <div v-if="isNavOpened">
        <sidebar ref="sidebar" v-click-outside="onCloseSidebar" />
      </div>
    </transition>
    <!-- Page Content -->
    <div
      v-if="isSearchOpened"
      class="blured-body"
      :class="{ 'mobile-responsive': isMobile }"
    />
    <main :class="{ 'mobile-responsive': isMobile, 'page-content': !isMobile }">
      <router-view />
    </main>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import Navigation from './components/Navigation'
import { mapActions, mapState } from 'vuex'
import Sidebar from './components/Sidebar'
import WindowResize from './components/WindowResize'
import { name as userModuleName } from '@/modules/user/store/'
import { name as appModuleName } from '@/modules/app/store'

import '@/assets/css/all.css'
import '@/assets/css/solid.css'
import '@/assets/css/style.css'
import '@/assets/css/mobile.css'

export default {
  name: 'MainLayout',

  components: {
    navigation: Navigation,
    sidebar: Sidebar,
    WindowResize,
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            const className = event.target.className
            if (!className.includes('burger')) {
              vnode.context[binding.expression](event)
            }
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
  },
  data() {
    return {
      isSearchOpened: false,
      windowWidth: 0,
    }
  },
  computed: {
    ...mapState(userModuleName, [
      'userMenu',
      'menuItemId',
      'user',
      'isLoggingOut',
    ]),
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    isNavOpened() {
      return this.$store.getters['$_app/getIsNavOpen']
    },
  },
  watch: {
    isLoggingOut(value) {
      if (value) {
        this.showCloseAlert()
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.userActivityThrottler)
    window.removeEventListener('scroll', this.userActivityThrottler)
    window.removeEventListener('keydown', this.userActivityThrottler)
    window.removeEventListener('resize', this.userActivityThrottler)
    clearTimeout(this.userActivityThrottlerTimeout)
  },
  mounted() {
    this.activateActivityTracker()
    window.location.hash = ''
  },
  methods: {
    async showCloseAlert() {
      this.ShowAlert(
        'La sesión ha expirado',
        'Debe iniciar sesión nuevamente para continuar.',
        'error',
        async () => {
          await this.$store.dispatch('$_user/logout')
        }
      )
    },
    onCloseSidebar() {
      if (this.$store.state.isMobileDensity) {
        this.toggleNav()
      }
    },
    activateActivityTracker() {
      window.addEventListener('mousemove', this.userActivityThrottler)
      window.addEventListener('scroll', this.userActivityThrottler)
      window.addEventListener('keydown', this.userActivityThrottler)
      window.addEventListener('resize', this.userActivityThrottler)
      window.addEventListener('beforeunload', this.deactivateActivityTracker)
    },
    deActivateActivityTracker() {
      window.removeEventListener('mousemove', this.userActivityThrottler)
      window.removeEventListener('scroll', this.userActivityThrottler)
      window.removeEventListener('keydown', this.userActivityThrottler)
      window.removeEventListener('resize', this.userActivityThrottler)
      window.removeEventListener('beforeunload', this.deactivateActivityTracker)
    },

    userActivityThrottler() {
      if (!this.sessionExpired) {
        clearTimeout(this.userActivityThrottlerTimeout)
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.handleSessionExpiration()
          clearTimeout(this.userActivityThrottlerTimeout)
        }, process.env.VUE_APP_SESSION_TIMEOUT * 60000)       
      }
    },
    async handleSessionExpiration() {
      this.sessionExpired = true
      await this.$store.commit('$_user/SET_USER_LOGOUT')
    },
    ...mapActions(userModuleName, ['setMenuItemId']),
    ...mapActions(appModuleName, ['toggleNav']),
  },
}
</script>

<style scope>
#main {
  margin-bottom: 30px;
}

.page-content {
  padding: 15px 30px;
  margin-left: 118px;
}

@media (max-width: 425px) {
  .page-content {
    padding: 0 !important;
  }
}

.blured-body {
  left: 119px;
  top: 100px;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 11;
}

.blured-body {
  backdrop-filter: blur(8px);
}
</style>
